function Asterisks({ asterisk }) {
    return asterisk == true && <span className="text-danger">*</span>;
}

export default Asterisks